import { IMAGES } from "./constants";

export default function CoverageBand() {
  return (
    <section
      data-testid="coverage-band"
      className="relative py-20 px-6 border-y border-white/10 overflow-hidden bg-[#0a1220]"
    >
      <img
        src={IMAGES.workshop}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1220] via-[#0a1220]/70 to-[#0a1220]/40"></div>
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 items-center relative z-10">
        <div className="md:col-span-2">
          <p className="font-mono-lbl text-xs text-[#ff4b2b] uppercase tracking-widest">
            Dayton&ndash;Cincinnati Mobile Coverage
          </p>
          <h3 className="text-2xl md:text-4xl font-extrabold uppercase mt-2">
            We service everyday drivers, commuters, and commercial fleets.
          </h3>
        </div>
        <div className="flex items-center gap-8 border-l border-white/10 pl-6">
          <div>
            <span className="text-3xl font-black text-cyan-300 font-mono-lbl">$0</span>
            <p className="text-xs text-slate-400 uppercase mt-1">Towing Cost Needed</p>
          </div>
          <div>
            <span className="text-3xl font-black text-[#ff4b2b] font-mono-lbl">Same-Day</span>
            <p className="text-xs text-slate-400 uppercase mt-1">Response Window</p>
          </div>
        </div>
      </div>
    </section>
  );
}
